
import jsPDF from 'jspdf';
import { PDF_STYLES } from './pdfStyles';

export const addFooter = (pdf: jsPDF, yPosition: number): void => {
  const { margin, fonts } = PDF_STYLES;
  
  yPosition += 20;
  pdf.setFontSize(fonts.tiny);
  pdf.setFont(undefined, 'normal');
  pdf.text('This report is generated automatically by Author\'s Tranquility Press system.', margin, yPosition);
  yPosition += 6;
  pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, margin, yPosition);
};
